/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Import_Csv_TitleInputs */

const en_knp_terms_import_csv_title = /** @type {(inputs: Knp_Terms_Import_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import terms from CSV`)
};

const fr_knp_terms_import_csv_title = /** @type {(inputs: Knp_Terms_Import_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer des termes depuis un CSV`)
};

const de_knp_terms_import_csv_title = /** @type {(inputs: Knp_Terms_Import_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begriffe aus CSV importieren`)
};

const it_knp_terms_import_csv_title = /** @type {(inputs: Knp_Terms_Import_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa termini da CSV`)
};

const ru_knp_terms_import_csv_title = /** @type {(inputs: Knp_Terms_Import_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт терминов из CSV-файла`)
};

const es_knp_terms_import_csv_title = /** @type {(inputs: Knp_Terms_Import_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar términos desde CSV`)
};

const zh_cn2_knp_terms_import_csv_title = /** @type {(inputs: Knp_Terms_Import_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从 CSV 文件导入条款`)
};

const ja_knp_terms_import_csv_title = /** @type {(inputs: Knp_Terms_Import_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSVから用語をインポートする`)
};

const hi_knp_terms_import_csv_title = /** @type {(inputs: Knp_Terms_Import_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV से शर्तें आयात करें`)
};

const pt_pt2_knp_terms_import_csv_title = /** @type {(inputs: Knp_Terms_Import_Csv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar termos de um arquivo CSV`)
};

/**
* | output |
* | --- |
* | "Import terms from CSV" |
*
* @param {Knp_Terms_Import_Csv_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_import_csv_title = /** @type {((inputs?: Knp_Terms_Import_Csv_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Import_Csv_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_import_csv_title(inputs)
	if (locale === "de") return de_knp_terms_import_csv_title(inputs)
	if (locale === "it") return it_knp_terms_import_csv_title(inputs)
	if (locale === "ru") return ru_knp_terms_import_csv_title(inputs)
	if (locale === "es") return es_knp_terms_import_csv_title(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_import_csv_title(inputs)
	if (locale === "ja") return ja_knp_terms_import_csv_title(inputs)
	if (locale === "hi") return hi_knp_terms_import_csv_title(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_import_csv_title(inputs)
	return en_knp_terms_import_csv_title(inputs)
});